import { render, staticRenderFns } from "./TopKCardItem.vue?vue&type=template&id=63370942&scoped=true"
import script from "./TopKCardItem.vue?vue&type=script&lang=js"
export * from "./TopKCardItem.vue?vue&type=script&lang=js"
import style0 from "./TopKCardItem.vue?vue&type=style&index=0&id=63370942&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63370942",
  null
  
)

export default component.exports